// The 'true' at the end forces this to run BEFORE any custom apps can block it
document.addEventListener('click', async (e) => {
  
  // 1. Hyper-aggressive selector: Finds the button even if an app stripped its tags
  const submitButton = e.target.closest('button[name="add"], .product-form__submit, button[type="submit"], form button:not([type="button"])');
  if (!submitButton) return;

  // 2. Find the form, bypassing app wrappers
  const formId = submitButton.getAttribute('form');
  const form = formId ? document.getElementById(formId) : submitButton.closest('form');
  if (!form) return;

  // 3. Find our gift card toggle
  const checkedToggle = document.querySelector('.gift-card-toggle:checked');

  // If the box isn't checked, OR if our script is currently processing, let the native code run
  if (!checkedToggle || submitButton.dataset.giftProcessing === 'true') {
    return; 
  }

  // Ensure we are on the Product Page block, not the Cart Page block
  const giftWrapper = checkedToggle.closest('[data-gift-wrapper]') || checkedToggle.parentElement;
  if (giftWrapper && giftWrapper.querySelector('[data-add-gift-to-cart]')) {
      return; 
  }

  // 4. Find the message input
  const messageInput = giftWrapper ? giftWrapper.querySelector('[data-message-input]') : document.querySelector('.gift-card-message-input');

  // 🛑 NEW: VALIDATION CHECK
  // If the box is checked but the textarea is completely empty
  if (messageInput && messageInput.value.trim() === '') {
    e.preventDefault();
    e.stopImmediatePropagation();

    // Trigger the native browser popup warning
    messageInput.setCustomValidity('Please enter your gift message.');
    messageInput.reportValidity();
    
    // Auto-focus the cursor inside the box for them
    messageInput.focus();

    // Clear the error state as soon as they start typing
    messageInput.addEventListener('input', () => {
      messageInput.setCustomValidity('');
    }, { once: true });

    return; // Abort the add-to-cart process completely
  }

  // 🛑 ALL SYSTEMS GO. Force-stop the theme and any custom apps.
  e.preventDefault();
  e.stopImmediatePropagation();

  const originalText = submitButton.innerHTML;
  submitButton.setAttribute('disabled', 'disabled');
  submitButton.innerHTML = '<span>Adding Gift...</span>';

  const giftVariantId = parseInt(checkedToggle.getAttribute('data-variant-id'), 10);
  const mainProductTitle = checkedToggle.getAttribute('data-main-product-title');
  const mainProductId = checkedToggle.getAttribute('data-main-product-id');
  const isSingleMode = checkedToggle.getAttribute('data-single-mode') === 'true';
  const giftMessage = messageInput.value.trim(); // We now know this definitely has text!

  // Build the backend payload
  let properties = {
    'Gift Message': giftMessage,
    '_Timestamp': Date.now() // Protects against array shifting
  };

  if (!isSingleMode) {
    properties['_Associated Product'] = mainProductTitle;
    properties['_Associated_Product_ID'] = mainProductId;
  }

  const giftPayload = {
    items: [{
      id: giftVariantId,
      quantity: 1,
      properties: properties
    }]
  };

  try {
    // Fire the gift card to the server
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(giftPayload)
    });

    if (!response.ok) throw new Error('Failed to add gift card.');

    // Wait exactly 300ms for Shopify to register the gift card, then fire the Main Product
    setTimeout(() => {
      // Tag the button so our script ignores the next simulated click
      submitButton.dataset.giftProcessing = 'true';
      submitButton.removeAttribute('disabled');
      submitButton.innerHTML = originalText;

      // Re-click the exact same button to allow the custom app / theme drawer to open natively
      submitButton.click();

      // Untag the button after 1 second so it can be used again
      setTimeout(() => {
        submitButton.dataset.giftProcessing = 'false';
      }, 1000);
      
    }, 300);

  } catch (error) {
    console.error('Network error during AJAX add to cart:', error);
    alert('Sorry, there was an issue adding the gift card.');
    submitButton.removeAttribute('disabled');
    submitButton.innerHTML = originalText;
    submitButton.dataset.giftProcessing = 'false';
  }
}, true);